export const BEFORE_UNLOAD = 'beforeunload';